import { setRelatedResources } from '../../utils/functions.utils'

export const setResourceMaps = (customerStories: any) => {
  const resourceTopics = new Map()
  const resourceRegion = new Map()
  const resourceIndustry = new Map()

  for (let i = 0; i < customerStories.length; i++) {
    if (customerStories[i].node) {
      let customerStory = customerStories[i].node
      let resourceRegionId
      let resourceIndustryId

      //group resourceRegion && resourceIndustry content
      if (customerStory.metaInformation && customerStory.metaInformation.length) {
        //limit resource region and industry to one per success story
        let counterResourceRegion = 0
        let counterResourceIndustry = 0
        let metaInformation = customerStory.metaInformation
        for (let j = 0; j < metaInformation.length; j++) {
          if (counterResourceRegion + counterResourceIndustry === 2) break
          if (metaInformation[j].__typename) {
            if (
              metaInformation[j].__typename === 'ContentfulTopicResourceRegion' &&
              counterResourceRegion++ === 0
            ) {
              resourceRegion.has(metaInformation[j].id)
                ? resourceRegion.set(metaInformation[j].id, [
                    ...resourceRegion.get(metaInformation[j].id),
                    customerStory,
                  ])
                : resourceRegion.set(metaInformation[j].id, [customerStory])
              resourceRegionId = metaInformation[j].id
            } else if (
              metaInformation[j].__typename === 'ContentfulTopicResourceIndustry' &&
              counterResourceIndustry++ === 0
            ) {
              resourceIndustry.has(metaInformation[j].id)
                ? resourceIndustry.set(metaInformation[j].id, [
                    ...resourceIndustry.get(metaInformation[j].id),
                    customerStory,
                  ])
                : resourceIndustry.set(metaInformation[j].id, [customerStory])
              resourceIndustryId = metaInformation[j].id
            }
          }
        }
      }

      //group resourceTopics
      if (customerStory.topics && customerStory.topics.length) {
        let topics = customerStory.topics
        for (let j = 0; j < topics.length; j++) {
          if (Object.keys(topics[j]).length === 0) continue
          resourceTopics.has(topics[j].id)
            ? resourceTopics.set(topics[j].id, [...resourceTopics.get(topics[j].id), customerStory])
            : resourceTopics.set(topics[j].id, [customerStory])
        }
      }

      if (resourceRegionId) customerStory['resourceRegionId'] = resourceRegionId
      if (resourceIndustryId) customerStory['resourceIndustryId'] = resourceIndustryId
    }
  }

  return { resourceTopics, resourceRegion, resourceIndustry }
}

export const getRelatedStoriesForPost = (
  resourceData: any,
  resourceTopics: any,
  resourceRegion: any,
  resourceIndustry: any
) => {
  if (!resourceData) return []
  let topics = resourceData.topics

  let relatedCustomerStories: any = []
  const seen = new Set()

  // check resource industry
  if (relatedCustomerStories.length < 3 && resourceData.resourceIndustryId) {
    if (resourceIndustry.has(resourceData.resourceIndustryId)) {
      setRelatedResources({
        relatedResourcesArray: relatedCustomerStories,
        relatedEntries: resourceIndustry.get(resourceData.resourceIndustryId),
        excludeId: resourceData.contentful_id,
        seen,
        featured: true,
        resourceLocale: resourceData.entryLocale,
      })
    }
  }

  // check resource region
  if (relatedCustomerStories.length < 3 && resourceData.resourceRegionId) {
    if (resourceRegion.has(resourceData.resourceRegionId)) {
      setRelatedResources({
        relatedResourcesArray: relatedCustomerStories,
        relatedEntries: resourceRegion.get(resourceData.resourceRegionId),
        excludeId: resourceData.contentful_id,
        seen,
        featured: true,
        resourceLocale: resourceData.entryLocale,
      })
    }
  }

  // check resource topics
  if (relatedCustomerStories.length < 3 && topics) {
    for (let i = 0; i < topics.length; i++) {
      if (resourceTopics.has(topics[i].id)) {
        setRelatedResources({
          relatedResourcesArray: relatedCustomerStories,
          relatedEntries: resourceTopics.get(topics[i].id),
          excludeId: resourceData.contentful_id,
          seen,
          featured: true,
          resourceLocale: resourceData.entryLocale,
        })
      }
      if (relatedCustomerStories.length === 3) break
    }
  }

  // check resource industry
  if (relatedCustomerStories.length < 3 && resourceData.resourceIndustryId) {
    if (resourceIndustry.has(resourceData.resourceIndustryId)) {
      setRelatedResources({
        relatedResourcesArray: relatedCustomerStories,
        relatedEntries: resourceIndustry.get(resourceData.resourceIndustryId),
        excludeId: resourceData.contentful_id,
        seen,
        featured: false,
        resourceLocale: resourceData.entryLocale,
      })
    }
  }

  // check resource region
  if (relatedCustomerStories.length < 3 && resourceData.resourceRegionId) {
    if (resourceRegion.has(resourceData.resourceRegionId)) {
      if (resourceRegion.has(resourceData.resourceRegionId)) {
        setRelatedResources({
          relatedResourcesArray: relatedCustomerStories,
          relatedEntries: resourceRegion.get(resourceData.resourceRegionId),
          excludeId: resourceData.contentful_id,
          seen,
          featured: false,
          resourceLocale: resourceData.entryLocale,
        })
      }
    }
  }

  // check resource topics
  if (relatedCustomerStories.length < 3 && topics) {
    for (let i = 0; i < topics.length; i++) {
      if (resourceTopics.has(topics[i].id)) {
        setRelatedResources({
          relatedResourcesArray: relatedCustomerStories,
          relatedEntries: resourceTopics.get(topics[i].id),
          excludeId: resourceData.contentful_id,
          seen,
          featured: false,
          resourceLocale: resourceData.entryLocale,
        })
      }
      if (relatedCustomerStories.length === 3) break
    }
  }

  return relatedCustomerStories
}
